import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MerchantCurrencyPipe } from '../pipes/merchant-currency.pipe';
import { PaymentMethodPipe } from '../pipes/payment-method.pipe';

/**
 * Booking payment summary when the sales module is off.
 * Shows collected payment rows, outstanding balance when due, and total paid (no sale CTAs).
 */
@Component({
    selector: 'app-booking-collected-payments-card',
    standalone: true,
    imports: [TranslatePipe, DatePipe, MerchantCurrencyPipe, PaymentMethodPipe],
    templateUrl: './booking-collected-payments-card.component.html',
})
export class BookingCollectedPaymentsCardComponent {
    @Input({ required: true }) sale!: {
        salePayments?: Array<{
            id?: number | null;
            paymentMethod?: string;
            isOnlinePayment?: boolean;
            paidAt?: string | Date;
            amount?: number;
        }>;
        tip?: number;
        paidAmount?: number;
        paidAmountCents?: number;
        missingPayment?: number;
        missingPaymentCents?: number;
    };

    get payments() {
        return this.sale?.salePayments ?? [];
    }

    get totalPaid(): number {
        if (this.sale?.paidAmount != null) {
            return Number(this.sale.paidAmount);
        }

        if (this.sale?.paidAmountCents != null) {
            return Number(this.sale.paidAmountCents) / 100;
        }

        return this.payments.reduce((sum, payment) => sum + (Number(payment.amount) || 0), 0);
    }
}
